<template>
  <b-table
    class="profiles-table"
    :data="values"
    :checkable="false">
    <template slot-scope="props">
      <template v-for="item in props.row">
        <b-table-column
          v-if="columns.includes(item.label)"
          :key="item.label"
          :label="item.label"
          :centered="Object.prototype.hasOwnProperty.call(item, 'centered')">
          <router-link v-if="item.link" :to="item.link">
            {{ item.value }}
          </router-link>
          <span v-else>{{ item.value }}</span>
        </b-table-column>
      </template>
    </template>
  </b-table>
</template>

<script>
import _ from 'lodash';
import organizations from '@/mixins/admin/organizations';

export default {
  name: 'OrganizationsTable',
  mixins: [organizations],
  props: {
    organizations: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        'Active',
        'Name',
        'Vanity',
        'Domain',
        'DB Migration',
        '# Assets',
        '# Users',
        '# Logs',
        '# Alerts',
        'Created',
      ],
    };
  },
  computed: {
    values() {
      return _.map(this.organizations, o => this.keyValues(o));
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
